import { Download } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";
import { generateICSContent } from "@core/features/calendar";
import type { Meeting } from "@core/features/meeting";

export type Props = {
  onClick?: () => void;
  meetings?: Meeting[];
  eventTitle: string;
  onAddCalendarEvent: (
    meetingId: number | "all",
    calendarType: "google" | "ical"
  ) => void;
  variant?: "primary" | "ghost";
};

export function DownloadICSButton({
  onClick,
  meetings,
  eventTitle,
  onAddCalendarEvent,
  variant = "primary",
}: Props) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (!meetings) return;

    const icsContent = generateICSContent(meetings, {
      eventTitle,
    });

    // Create blob and trigger download
    const blob = new Blob([icsContent], {
      type: "text/calendar;charset=utf-8",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "pollinator-meetings.ics";

    onAddCalendarEvent("all", "ical");

    link.click();

    URL.revokeObjectURL(url);

    onClick?.();
  };

  return (
    <Button variant={variant} iconComponent={Download} onClick={handleClick}>
      Download All Events (.ics)
    </Button>
  );
}

export default DownloadICSButton;
